import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=17a0d1ea&"
import script from "./tab-item.vue?vue&type=script&lang=js&"
export * from "./tab-item.vue?vue&type=script&lang=js&"
import style0 from "./tab-item.vue?vue&type=style&index=0&lang=scss&scorped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports